<span
  *ngFor="let item of items"
  class="loader"
  [ngClass]="{ circle: appearance === 'circle' }"
  [ngStyle]="styles"
>
</span>
